const handleSuccessRequestSchedule = ({ detail }) => {
  try {
    const {
      allButtonList,
      allToggleButtonWrapList,
      allScheduleContainerList,
      wrapperRowButtonList,
      wrapperRowScheduleContainer,
      wrapperRowToggleButtonWrapList,
    } = detail.scheduleElements

    allButtonList.forEach(el => el.classList.remove('d-none'))
    allScheduleContainerList.forEach(el => el.classList.add('d-none'))
    allToggleButtonWrapList.forEach(el => el.classList.add('d-none'))

    wrapperRowButtonList.forEach(el => el.classList.add('d-none'))
    wrapperRowToggleButtonWrapList.forEach(el => el.classList.remove('d-none'))

    if (wrapperRowScheduleContainer) {
      wrapperRowScheduleContainer.classList.remove('d-none')
    }
  } catch { /* Empty */ }
}

export default handleSuccessRequestSchedule
